import { Box, Card } from "@mui/material";
import _ from "lodash";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { GraphDataNotAvailable } from "../../../common/components/GraphDataNotAvailable";
import { GraphLoadingScreen } from "../../../common/components/GraphLoadingScreen";
import type { RawData } from "../../../common/interface/interface";
import { generateColorFromString } from "../../../common/utils/gen-random-color";
import { multivariantGroupByTime } from "../../../common/utils/multi-variant-transform-data";

import "./variate-graph.css";

type Props = {
  chartViewMode: "individual" | "combined";
  graphData: RawData;
  graphDataLoading: boolean;
};

function MultiVariateGraph({
  chartViewMode,
  graphData,
  graphDataLoading,
}: Props) {
  const showMultiVariateGraph = chartViewMode === "combined";

  if (!showMultiVariateGraph) return null;

  if (graphDataLoading) return <GraphLoadingScreen />;

  const isGraphDataNotAvailable = _.isEmpty(graphData);

  if (isGraphDataNotAvailable) return <GraphDataNotAvailable />;

  const { sortedMetricsData, metrics } = multivariantGroupByTime(graphData);

  return (
    <Card
      sx={{ my: 2, boxShadow: 3, borderRadius: 2, p: 2, overflow: "visible" }}
    >
      <Box
        sx={{
          mb: 2,
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          overflow: "visible",
        }}
      >
        <ResponsiveContainer
          width="100%"
          height={180}
          style={{
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
          }}
        >
          <LineChart data={sortedMetricsData}>
            <Tooltip />
            {metrics?.map((metric) => {
              return (
                <Line
                  type="monotone"
                  dataKey={metric}
                  key={metric}
                  stroke={generateColorFromString(metric)}
                  strokeWidth={2}
                  dot={false}
                />
              );
            })}
            <XAxis dataKey="_time" hide={true} />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
}

export { MultiVariateGraph };
